import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { InHomeUtils } from './../util/inhomeUtils';
import { connect } from 'react-redux'

class promoMessage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.isReskin = this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
    }
    render() {
        let template = <div></div>;

        if(InHomeUtils.isNotNull(this.props?.message)){
            template = <div className="columns tiny-12 padding-vert-zero promo belowctrtheader m_agreement-promo promo_header_accordion">
                        <span className={!this.isReskin ? "bold" : "promo_header_reskin"}>{ReactHtmlParser(this.props?.message?.replace('Fios','Xbox')?.replace('[1 Gig]', 'Gigabit'))}</span></div>
        }

        return (
            <React.Fragment>
              {template}
           </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        buildProductState: state.buildProduct
    }
}
export default connect(
    mapStateToProps
)(promoMessage);